import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import MpgErrorDialog from "../../../../common/dialog/MpgErrorDialog";
import EditAdminUser from "./EditAdminUser";
import { useGetAdminUserByIdQuery, useGetCountryListOnlyForRightTractByLocaleQuery, useGetTimeZoneListForAdminUserQuery } from "../../../../reactQueries/AppApi/rqHooksForAdminUser";
import { useGetSiteCoreCMSData } from "../../../../reactQueries/commonRQHooks";
const EditAdminUserHome = () => {
  const {isSuccess: isSuccessOnSiteCoreCMS, error: errorOnSiteCoreCMS, data: adminUserCMSDataFromAPI, isError: isErrorOnSiteCoreCMS, isFetching: isFetchingOnSiteCoreCMS} = useGetSiteCoreCMSData({pagename: "Users"});
  const [adminUserCMSData, setAdminUserCMSData] = useState({title: "", description: "",tabNavigationTitle: "",pageContent: {},});

  let { id } = useParams();
  /**API calls */
  const {
    isSuccess,
    isFetching,
    error,
    data: adminUserDataById,
    isError,
    isFetched,
  } = useGetAdminUserByIdQuery({ adminUserId: id });

  // console.log("adminUserDataById111:", adminUserDataById)

  /**get timezonesList */
  const {
    isSuccess: isSuccessOnTimezone,
    isFetching: isFetchingOnTimezone,
    error: errorOnTimezone,
    isError: isErrorOnTimezone,
    data: timezonesListForAdminUser,
  } = useGetTimeZoneListForAdminUserQuery();

  /**get CountryListByLocale*/
  const {
    isSuccess: isSuccessOnCountryListByLocale,
    isFetching: isFetchingOnCountryListByLocale,
    error: errorOnCountryListByLocale,
    isError: isErrorOnCountryListByLocale,
    data: countryListForRTByLocale,
  } = useGetCountryListOnlyForRightTractByLocaleQuery();

  const fetchAdminUserCMSData = () =>{
    if(adminUserCMSDataFromAPI && adminUserCMSDataFromAPI.Pages){
     adminUserCMSDataFromAPI.Pages.map((el) => {
       if (el.Key === "UserAccounts") {
         const { Title, Description, TabNavigationTitle, Components } = el;
         setAdminUserCMSData({ title: Title, description: Description, tabNavigationTitle: TabNavigationTitle, pageContent: Components });
       }
   });
    }
  }

  const fetchCommonCMSLabel = (key) => {
    if (adminUserCMSData && adminUserCMSData?.pageContent["CommonComponent"]) {
        const adminUserCMSDataLabel = adminUserCMSData.pageContent["CommonComponent"];
        return returnLabel(adminUserCMSDataLabel?.Labels, key)
    }
    return '';
  }

  const returnLabel = (labelArray=[], key) => {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
}


  useEffect(() => {
    fetchAdminUserCMSData();
   }, [adminUserCMSDataFromAPI]);
   
  return (
    <div>
      {
        (!!isFetching) && fetchCommonCMSLabel('Common.Waitloading')
      }
      {!!isSuccess && !!adminUserDataById && (
        <EditAdminUser
          adminUserDataById={adminUserDataById}
          timezonesListForAdminUser={timezonesListForAdminUser || []}
          countryListForRTByLocale={countryListForRTByLocale || []}
          adminUserCMSData={adminUserCMSData}
        />
      )}

      <MpgErrorDialog
        open={!!isError}
      />
    </div>
  );
};
export default EditAdminUserHome;
